export const initializeGTM = (gtmId: string) => {
  // Initialize dataLayer
  globalThis.dataLayer ??= [];

  // Add GTM script to head
  const gtmScript = document.createElement('script');
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

  // Add GTM initialization code
  const gtmInitScript = document.createElement('script');
  gtmInitScript.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `;

  document.head.appendChild(gtmInitScript);
  document.head.appendChild(gtmScript);

  // Add noscript iframe to body
  const noscript = document.createElement('noscript');
  noscript.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
            height="0" width="0" style="display:none;visibility:hidden">
    </iframe>
  `;
  document.body.appendChild(noscript);
};
